export default [  
  
  {
    path: '/contributions/outstanding',
    props: true,
    name: 'contributions-outstanding',
    component: () => import('@/views/modules/contributions/outstanding'),
    meta: {
      sidebarToggle: false,
      requiresAuth: true,
      layout: 'app',
      title:'Outstanding Contributions',
      breadcrumb: [
        { text: 'Home',  to: { name: "home" } },
        { text: 'Outstanding' }
      ]
    }
  },

  {
    path: '/contributions/processed',
    props: true,
    name: 'contributions-processed',
    component: () => import('@/views/modules/contributions/processed'),
    meta: {
      sidebarToggle: false,
      requiresAuth: true,
      layout: 'app',
      title:'Processed Contributions',
      breadcrumb: [
        { text: 'Home',  to: { name: "home" } },
        { text: 'Processed' }
      ]
    }
  },

  {
    path: '/contributions/ad-hoc',
    props: true,
    name: 'contributions-ad-hoc',
    component: () => import('@/views/modules/contributions/ad-hoc'),
    meta: {
      sidebarToggle: false,
      requiresAuth: true,
      layout: 'app',
      title:'Ad Hoc Contribution',
      breadcrumb: [
        { text: 'Home',  to: { name: "home" } },
        { text: 'Add' }
      ]
    }
  },

  {
    path: '/contributions/debits',
    props: true,
    name: 'contributions-debits',
    component: () => import('@/views/modules/contributions/debits'),
    meta: {
      sidebarToggle: false,
      requiresAuth: true,
      layout: 'app',
      title:'Scheme Debits',
      breadcrumb: [
        { text: 'Home',  to: { name: "home" } },
        { text: 'Debits' }
      ]
    }
  },

 
]